import React from 'react'
import './MeetingTypeIcon.scss'
import { IntegrationIcon } from '../../../../../components/IntegrationIcon'
import { IntegrationServiceId } from '../../../../../common/integrations'

export interface MeetingTypeIconProps {
  meetingType: string
}

export const MeetingTypeIcon: React.FC<MeetingTypeIconProps> = ({ meetingType }) => {
  switch (meetingType) {
    case 'zoom':
      return <IntegrationIcon serviceId={IntegrationServiceId.ZOOM} className='meeting-type-icon' />
    case 'teams':
      return <IntegrationIcon serviceId={IntegrationServiceId.TEAMS} className='meeting-type-icon' />
    case 'meet':
      return <IntegrationIcon serviceId={IntegrationServiceId.MEET} className='meeting-type-icon' />
    case 'phone':
      return <i className='bi bi-telephone-fill' />
    case 'voice-memo':
      return <i className='bi bi-person-fill' />
    case 'voice-memo-desktop':
      return <i className='bi bi-person-fill' />
    case 'voice-memo-mobile':
      return <i className='bi bi-person-fill' />
    case 'webex':
      return <IntegrationIcon serviceId={IntegrationServiceId.WEBEX} className='meeting-type-icon' />
    case 'phone-ringcentral':
      return <IntegrationIcon serviceId={IntegrationServiceId.RINGCENTRAL} className='meeting-type-icon' />
    case 'phone-goto':
      return <IntegrationIcon serviceId={IntegrationServiceId.GOTO} className='meeting-type-icon' />
    case 'phone-zoom_phone':
      return <IntegrationIcon serviceId={IntegrationServiceId.ZOOM} preferPhone className='meeting-type-icon' />
    default:
      return <i className='bi bi-clipboard-minus meeting-type-icon' />
  }
}
